module.exports = "//static.hsappstatic.net/growth-onboarding-confetti/static-1.710/images/sprocket.svg"